import { RouterProvider } from 'react-router-dom';
import { Theme } from '@newcore/ui/enums/theme';
import { TooltipProvider } from '@newcore/ui/tooltips';
import { ErrorBoundary } from './components/error-boundary';
import { ThemeProvider } from './providers/theme-provider';
import { router } from './router/index.tsx';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme={Theme.LIGHT} storageKey='user-portal-theme'>
        <TooltipProvider>
          <RouterProvider router={router} />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
